var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('p',{staticClass:"text-muted",staticStyle:{"background-color":"#f5f5f5","margin":"0","padding":"0.5em 0","height":"4em"}},[_vm._v(" CVBB ACM/ICPC 集训队 2005-2023 "),_c('br'),_c('a',{staticClass:"text-muted",attrs:{"href":"http://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("京ICP备20018844号-3")])])])
}]

export { render, staticRenderFns }